package app.model

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class RolloutExecution(
    val id: Int,
    val companyProjectStageId: Int,
    val stageId: Int,
    val stageName: String,
    val companyId: Int,
    val companyName: String,
    val releaseId: Int,
    val logs: String,
    val status: String,
    val startedAt: Instant,
    val finishedAt: Instant?,
    val version: Version
)